import { create } from 'zustand';
import { devtools, redux } from 'zustand/middleware';
import { searchInitialState } from './searchInitialState';
import { searchReducer } from './searchReducer';

export const useSearchStore = create(
  devtools(redux(searchReducer, searchInitialState), {
    name: 'SearchStore',
  }),
);
